import cx from 'classnames';

import s from './ContentContainer.module.css';

type TProps = {
  className?: string;
  children: React.ReactNode;
};

export const ContentContainer = ({ children, className }: TProps) => (
  <div className={cx(s.root, className)}>{children}</div>
);
